import React from 'react';
import ReactDOM from 'react-dom';

import { applyMiddleware, combineReducers, createStore } from 'redux'
import { Provider } from 'react-redux'

import { Route } from 'react-router'

import { ConnectedRouter, routerMiddleware, routerReducer } from 'react-router-redux'

import logger from 'redux-logger'
import registerServiceWorker from './registerServiceWorker';

import Home from './views/Home';
import Vote from './views/Vote';
import Thanks from './views/Thanks';
import ParentDiv from './views/ParentDiv';

import history from './history'

import * as reducers from './reducers';

import './index.css';
import './util/helpers/i18n';
import { isValidJSON, returnValueIfNotEmpty } from './util/helpers/Helpers';

const middleware = routerMiddleware(history)
const store = createStore(
  combineReducers({
    ...reducers,
    router: routerReducer
  }),
  applyMiddleware(middleware, logger)
);


const syncOmnihub = (event) => {
  console.log('ohb-data-event', event);
  if (event && event.data && isValidJSON(event.data)) {
    let omnihubData = JSON.parse(event.data);
    console.log('ohb-data-receive', omnihubData);
    if (omnihubData) {
      let prefilData = {
        firstname: returnValueIfNotEmpty(omnihubData.firstname),
        lastname: returnValueIfNotEmpty(omnihubData.lastname),
        email: returnValueIfNotEmpty(omnihubData.email),
        address: returnValueIfNotEmpty(omnihubData.address),
        postcode: returnValueIfNotEmpty(omnihubData.postcode),
        state: returnValueIfNotEmpty(omnihubData.state),
        dob: returnValueIfNotEmpty(omnihubData.dob)
      }
      localStorage.setItem('omnihubPrefilData', JSON.stringify(prefilData));
    }
  }
};
window.addEventListener('message', syncOmnihub);


const token = localStorage.getItem('token');
if (token) {
  store.dispatch({ type: 'AUTHENTICATED' });
}

const restrictedNames = ['/vote', '/thanks'];

if ((window && window.location && window.location.hash)
  || window.location.pathname === "/"
  || restrictedNames.includes(window.location.pathname)) {
  console.log('has hash');
  // [hash removal] remove this after hash migration
  ReactDOM.render(
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <div>
          <Route path="*" component={ParentDiv} />
          <Route exact path="/" component={Home} />
          <Route path="/vote" component={Vote} />
          <Route path="/thanks" component={Thanks} />
        </div>
      </ConnectedRouter>
    </Provider>,
    document.getElementById('root')
  )
} else {
  ReactDOM.render(
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <div>
          <Route path="*" component={ParentDiv} />
          <Route exact path="/:brand/:act" component={Home} />
          <Route exact path="/:brand/:act/vote" component={Vote} />
          <Route exact path="/:brand/:act/thanks" component={Thanks} />
        </div>
      </ConnectedRouter>
    </Provider>,
    document.getElementById('root')
  )
}



registerServiceWorker();
